<template>
  <div>
    <EquipmentEditHeader
      v-if="isAdmin"
      data-cy="sensor-search-view-edit-header"
    />
    <EquipmentTable
      data-cy="sensor-search-view-table"
      @select="$emit('select', $event.data as Sensors)"
    />
  </div>
</template>

<script setup lang="ts">
import { provide } from "vue";
import { useSensors } from "@/composables/equipment/sensors/sensors";
import EquipmentEditHeader from "@/components/equipment/EquipmentEditHeader.vue";
import EquipmentTable from "@/components/equipment/EquipmentTable.vue";
import type { Sensors } from "gql/api";

const props = defineProps<{
  isAdmin: boolean;
}>();

defineEmits<{
  (event: "select", data: Sensors): void;
}>();

const sensorsearch = useSensors(props.isAdmin);

provide("equipment", sensorsearch);
</script>
